// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"64def509","453":"7067b398","472":"898a2d07","803":"79378ee4","942":"5ea14212"}[chunkId] + ".chunk.js";
};